import {
  extractSalary,
  formattedRate,
} from "../../../../components/common/Converter";
import {
  calculate,
  calculateArray,
  getSumContributions,
  getSumCsvData,
  getTotalNetOfMandatory,
  getExactNetOfMandatory,
  getTaxableAllowances,
  createLookup,
  getDaysInMonth,
  calculateBackPay,
  groupAndSumByMonth,
  sumObjContributions,
  calculateAmount,
  extractDayNumbers,
  getSumAdditional,
  getRangeInSelectedDate,
  getInServiceCount,
  excludeLeaveFromAbsences,
  getActualAttendanceDates,
} from "../helper-payroll/HelperFunction";

export const calculations = (
  objects,
  selectedTypes,
  requestLists,
  otherInfo,
  datePicked,
  value = "",
  updatedObj
) => {
  console.log("updatedObj", updatedObj);
  const { jobTypeVal, payItems, payrollTypes } = selectedTypes;
  const {
    csv,
    numberOfDutiesinAP,
    lateUndertimeMins,
    monthIndex,
    natureOfFunction,
    monthFrom,
    monthTo,
  } = otherInfo;
  const {
    regular,
    airport,
    absentDateByEmployee = {},
    halfDateByEmployee = {},
    leaveWithoutPaySet = {},
  } = lateUndertimeMins || {};

  console.log("lateUndertimeMins", lateUndertimeMins);

  console.log("absentDateByEmployee", absentDateByEmployee);
  console.log("halfDateByEmployee", halfDateByEmployee);

  const rawStartDate = datePicked?.startDate;
  const dateObj = new Date(rawStartDate);

  const formatted = `${dateObj.toLocaleString("en-US", {
    month: "long",
  })} - ${dateObj.getFullYear()}`;

  const daysInMonth = getDaysInMonth(datePicked || {});

  const payrollCode = otherInfo?.payrollCode;

  const taxes = requestLists?.extractedTaxes ?? [];
  const allowances = requestLists?.allowanceLists?.allowance ?? [];
  const contributions = requestLists?.contributionListMap ?? [];
  const mandatoryFormula = requestLists?.mandatoryFormula ?? {};
  const hasIncentives =
    Array.isArray(requestLists?.incentives) &&
    requestLists.incentives.length > 0;

  const otherAdditional = hasIncentives
    ? requestLists.incentives[0].otherAdditionals
    : undefined;
  const otherDeductions = hasIncentives
    ? requestLists.incentives[0].otherDeductions
    : undefined;

  // console.log("contributions", contributions);

  const sumContributions = getSumContributions(contributions, "specific");
  const sumallContributions = getSumContributions(contributions, "all");
  const sumallAdditional = getSumAdditional(otherAdditional, csv);
  const sumallDeductions = getSumAdditional(otherDeductions, csv);

  // console.log("contributions", contributions);

  // console.log("sumallContributions", sumallContributions);

  // const sumObjectContributions

  const sumCsvData = getSumCsvData(csv, "all");
  const taxFromCsv = getSumCsvData(csv, "tax");
  const taxPercentFromCsv = getSumCsvData(csv, [2, 5, 10]);
  const deductionsFromCsv = getSumCsvData(csv, [2, 5, 10], { exclude: true });

  const sumTaxableAllowance = getTaxableAllowances(allowances, "Yes");
  const gratuityAllowance = getTaxableAllowances(
    allowances,
    "No",
    "GRATUITY PAY"
  );

  const rataAllowance = getTaxableAllowances(allowances, "No", "RATA");
  const daysToBeDeduc = createLookup(updatedObj, "id", "daysToBeDeducted");
  const halfdaysDeduc = createLookup(updatedObj, "id", "halfDaysToBeDeducted");
  const minsToBeDeduc = createLookup(updatedObj, "id", "minutesToBeDeducted");
  const minsToBeDeducted = createLookup(updatedObj, "id", "minsToBeDeducted");
  const daysInaMonth = createLookup(updatedObj, "id", "daysInAMonth");
  const periodCount = createLookup(updatedObj, "id", "updatedCountPrd");
  const overPaymentBasic = createLookup(updatedObj, "id", "overpaymentBasic");
  const overPaymentPera = createLookup(updatedObj, "id", "overpaymentPeraAda");
  const ovrPayment = createLookup(updatedObj, "id", "overpayment");
  const flgRaising = createLookup(updatedObj, "id", "flagRaising");
  const apRateAmount = createLookup(updatedObj, "id", "apRate");
  const updatedTax = createLookup(updatedObj, "id", "tax");
  const minsIncurred = createLookup(updatedObj, "id", "allMinsIncurred");
  const dateOfAbsences = createLookup(updatedObj, "id", "dateOfAbsences");

  const three = createLookup(updatedObj, "id", "3");
  const two = createLookup(updatedObj, "id", "2");
  const five = createLookup(updatedObj, "id", "5");
  const ten = createLookup(updatedObj, "id", "10");

  const numOfDays = createLookup(updatedObj, "id", "noOfDays");
  const taxArr = createLookup(updatedObj, "id", "tax");
  const monthNamesArr = createLookup(updatedObj, "id", "monthNamesArr");

  const gsisLR = createLookup(updatedObj, "id", "gsisLR");
  const phic = createLookup(updatedObj, "id", "phic");
  const pagibigArr = createLookup(updatedObj, "id", "pagibig");
  const dutyForCiaMciaBinoc = createLookup(
    updatedObj,
    "id",
    "OfDutyForCiaMciaBinocRangeTo1519"
  );
  const daysDeducForReg = createLookup(updatedObj, "id", "abs");
  const minsDeducForReg = createLookup(updatedObj, "id", "latesUtPerMinute");
  const daysDeducForAirport = createLookup(updatedObj, "id", "abs2");
  const minsDeducForAirport = createLookup(
    updatedObj,
    "id",
    "latesUtPerMinute2"
  );

  const noOfDutiesInAirport = createLookup(updatedObj, "id", "noOfDuties");
  const workingDatesLists = createLookup(updatedObj, "id", "workingDates");


  const minsToDeducAdd = createLookup(
    regular,
    "employeeId",
    "totalDeductedMins"
  );
  const minsIncurredLists = createLookup(
    regular,
    "employeeId",
    "allMinsIncurred"
  );
  const minsToDeducAirport = createLookup(
    airport,
    "employeeId",
    "totalDeductedMins"
  );

  const daysToDedudAdd = createLookup(regular, "employeeId", "totalAbsences");

  console.log("regular", regular);
  const actualWorkDays = createLookup(regular, "employeeId", "workingDates");
  const absencesDate = createLookup(regular, "employeeId", "dateOfAbsences");

  const daysToDeducAirport = createLookup(
    airport,
    "employeeId",
    "totalAbsences"
  );

  const halfDaysDeducdAdd = createLookup(
    regular,
    "employeeId",
    "totalHalfDays"
  );
  const mandatory = createLookup(contributions, "id", "contributions");

  console.log("mandatory", mandatory);

  const excessAirport = createLookup(updatedObj, "id", "excessAirportDuties");

  const workingDays = createLookup(regular, "employeeId", "totalWorkingDays");

  const firstCase = payrollTypes === "BP" && payItems === "General Payroll";
  const secondCase =
    payrollTypes === "BP" &&
    jobTypeVal !== "Job Order" &&
    payItems === "Addendum Payroll";
  const thirdCase = payrollTypes === "BP" && payItems === "Addendum Back-Pay";
  const fourthCase =
    payrollTypes === "AP" &&
    (payItems === "General Payroll" || payItems === "Newly-Hired");
  const fifthCase =
    payrollTypes === "BP" &&
    jobTypeVal === "Job Order" &&
    payItems === "Salary";
  const sixthCase =
    payrollTypes === "BP" &&
    jobTypeVal === "Job Order" &&
    payItems === "Addendum Payroll";
  const seventhCase =
    payrollTypes === "IP" &&
    jobTypeVal !== "Job Order" &&
    (payItems === "Initial" || payItems === "Last");
  const eightCase =
    payrollTypes === "IP" &&
    (payItems === "Initial AP" || payItems === "Last AP");
  const ninthCase = payrollTypes === "IP" && payItems === "Rata";
  const tenthCase = payrollTypes === "IP" && payItems === "SalaryDiffBasic";
  const eleventhCase =
    payrollTypes === "IP" &&
    jobTypeVal === "Job Order" &&
    (payItems === "Initial" || payItems === "Last");
  const twelveCase = payrollTypes === "AP" && payItems === "Back-Pay";
  const tirteenthCase =
    payrollTypes === "SP" && payItems !== "20% Monthly Premium";
  const fourteenthCase =
    payrollTypes === "SP" && payItems === "20% Monthly Premium";

  if (
    !firstCase &&
    !secondCase &&
    !thirdCase &&
    !fourthCase &&
    !fifthCase &&
    !sixthCase &&
    !seventhCase &&
    !eightCase &&
    !ninthCase &&
    !tenthCase &&
    !eleventhCase &&
    !twelveCase &&
    !tirteenthCase &&
    !fourteenthCase
  )
    return {};

  const firstCaseLists = {};
  const secondCaseLists = {};
  const thirdCaseLists = {};
  const fourthCaseLists = {};
  const fifthCaseLists = {};
  const sixthCaseLists = {};
  const seventhCaseLists = {};
  const eightCaseLists = {};
  const ninthCaseLists = {};
  const tenthCaseLists = {};
  const eleventhCaseLists = {};
  const twelveCaseLists = {};
  const tirteenthCaseLists = {};
  const fourteenthCaseLists = {};

  for (const [
    index,
    {
      id,
      salaryGrade,
      nonRegPosition,
      agency,
      payCode,
      monthlyTax,
      annualTax,
      netOfMandatory,
      monthlyPayCode,
      isGraduated,
      percentTag,
      isSubmitted,
      twentyFourSeven,
      earnedForThePeriod,
      oldRate,
      gsisInsuredDays,
      mandatoryDeductions,
      daysInAmonth,
      oldSalaryGrade,
      oldPositionTitle,
      netEarned,
      earnedBasic,
      daysToBeDeducted,
      halfDaysToBeDeducted,
      minutesToBeDeducted,
    },
  ] of objects.entries()) {
    const salary = salaryGrade
      ? extractSalary(salaryGrade)
      : extractSalary(nonRegPosition?.montlhyRate);

    const matchContributions = sumallContributions[id] ?? 0;
    const matchCsv = sumCsvData[agency] ?? 0;
    const tax = taxFromCsv[agency] ?? 0;

    const daysTobeDeduc = daysToDedudAdd[id];

    // const gsisInsuredDays = calculate(daysInMonth, [
    //   {
    //     type: "subtract",
    //     value: daysTobeDeduc,
    //   },
    // ]);

    const totalNetMandatory = getTotalNetOfMandatory(
      formatted,
      netOfMandatory,
      "Basic Pay",
      "netOfMandatory"
    );

    const totalMonthlyTax = getTotalNetOfMandatory(
      formatted,
      monthlyTax,
      "Basic Pay",
      "monthlyTax"
    );
    if (firstCase) {
      const pera = 2000;
      const overpaymentPeraAda = value[index]?.["overpaymentPeraAda"] ?? 0;
      const overpaymentBasic = value[index]?.["overpaymentBasic"] ?? 0;

      const earnedBasic = calculate(salary, [
        { type: "subtract", value: overpaymentBasic },
      ]);
      const earnedPeraAda = calculate(pera, [
        { type: "subtract", value: overpaymentPeraAda },
      ]);

      // const taxLawTotal = calculateTaxLaw(
      //   earnedBasic,
      //   taxes,
      //   sumTaxableAllowance[id],
      //   sumallContributions[id],
      //   0,
      //   totalNetMandatory,
      //   monthIndex,
      //   totalMonthlyTax,
      //   salary
      // );

      // const tax = taxLawTotal?.totalTax ?? 0;
      // const netMandatory = taxLawTotal?.netMandatory ?? 0;
      // const taxDue = taxLawTotal?.taxDue ?? 0;

      const netAmount = calculate(earnedBasic, [
        { type: "add", value: earnedPeraAda },
        {
          type: "subtract",
          value: tax + matchContributions + matchCsv,
        },
      ]);

      firstCaseLists[id] = {
        payrollCode,
        pera,
        overpaymentPeraAda,
        overpaymentBasic,
        earnedBasic,
        earnedPeraAda,
        tax,
        netAmount,
        // netMandatory,
        // taxDue,
        // daysInMonth,
        // gsisInsuredDays,
      };
    } else if (secondCase) {
      const pera = 2000;
      let minsToBeDeduc = minsToDeducAdd[id];
      const daysTobeDeduc = daysToDedudAdd[id];
      const halfDaysDeduc = halfDaysDeducdAdd[id];

      const dateOfAbsencesById = absentDateByEmployee[id];
      const dateOfHalfDaysById = halfDateByEmployee[id];
      const dateOfLeavesById = leaveWithoutPaySet[id];

      let gsisLR = mandatory[id]?.gsisLR;
      let phic = mandatory[id]?.pagibig;
      let pagibig = mandatory[id]?.phic;

      const actualAbsenceDates = excludeLeaveFromAbsences(
        absencesDate[id],
        leaveWithoutPaySet
      );

      const dateOfAbsences = extractDayNumbers(actualAbsenceDates[id]);
      const dateOfHalfDays = extractDayNumbers(dateOfHalfDaysById);
      const dateOfLeaves = extractDayNumbers(dateOfLeavesById);

      const periodCount = getRangeInSelectedDate(datePicked);

      const overpaymentPeraAda = value[index]?.["overpaymentPeraAda"] ?? 0;
      const overpaymentBasic = value[index]?.["overpaymentBasic"] ?? 0;

      // const daysToBeDeducted = calculate(daysInMonth, [
      //   {
      //     type: "subtract",
      //     value: daysTobeDeduc,
      //   },
      // ]);

      const gsisInsuredDays = calculate(periodCount, [
        {
          type: "subtract",
          value: daysTobeDeduc,
        },
      ]);

      const gsis = calculate(gsisInsuredDays, [
        { type: "divide", value: daysInMonth },
        { type: "multiply", value: gsisLR },
      ]);

      const mandatoryDeduc = sumObjContributions(contributions);

      const totalMandatory = calculate(mandatoryDeduc[id], [
        { type: "add", value: gsis },
      ]);

      const firctCalcForTardy = calculate(daysTobeDeduc, [
        { type: "multiply", value: salary },
        {
          type: "divide",
          value: 22,
        },
      ]);

      const secondCalcForTardy = calculate(halfDaysDeduc, [
        { type: "multiply", value: salary },
        {
          type: "divide",
          value: 22,
        },
        {
          type: "divide",
          value: 2,
        },
      ]);

      const thirdCalcForTardy = calculate(minsToBeDeduc, [
        { type: "multiply", value: salary },
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
      ]);

      const leaveAbsenceTardyDeducts = calculate(firctCalcForTardy, [
        { type: "add", value: secondCalcForTardy },
        { type: "add", value: thirdCalcForTardy },
      ]);

      const firctCalcForPera = calculate(daysTobeDeduc, [
        { type: "multiply", value: pera },
        {
          type: "divide",
          value: 22,
        },
      ]);

      const secondCalcForPera = calculate(halfDaysDeduc, [
        { type: "multiply", value: pera },
        {
          type: "divide",
          value: 22,
        },
        {
          type: "divide",
          value: 2,
        },
      ]);

      const thirdCalcForPera = calculate(minsToBeDeduc, [
        { type: "multiply", value: pera },
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
      ]);

      const peraDeducts = calculate(firctCalcForPera, [
        { type: "add", value: secondCalcForPera },
        { type: "add", value: thirdCalcForPera },
      ]);

      const earnedBasic = calculate(salary, [
        { type: "subtract", value: leaveAbsenceTardyDeducts },
        { type: "subtract", value: overpaymentBasic },
      ]);

      const earnedPeraAda = calculate(pera, [
        { type: "subtract", value: peraDeducts },
        { type: "subtract", value: overpaymentPeraAda },
      ]);

      // if()

      // const contrib = contributions.filter((obj) => obj.id === id);
      // const fItem = contrib[0];
      // const cont = fItem?.contributions;
      // const excludeKey = "gsisLR";

      // const otherContributionsSum = Object.entries(cont)
      //   .filter(([key]) => key !== excludeKey)
      //   .reduce((sum, [, value]) => sum + parseFloat(value || 0), 0);

      // const totalContribution = parseFloat(
      //   (otherContributionsSum + gsis).toFixed(2)
      // );

      // const taxLawTotal = calculateTaxLaw(
      //   earnedBasic,
      //   taxes,
      //   sumTaxableAllowance[id],
      //   sumallContributions[id],
      //   totalContribution,
      //   totalNetMandatory,
      //   monthIndex,
      //   totalMonthlyTax,
      //   salary
      // );

      // const tax = taxLawTotal?.totalTax ?? 0;
      // const netMandatory = taxLawTotal?.netEarnings ?? 0;
      // const taxDue = taxLawTotal?.taxDue ?? 0;

      let sumOfTotalMandatory = 0;
      let sumOfTotalCsv = 0;
      let sumOfTax = 0;

      if (earnedBasic === 0 && earnedPeraAda === 0) {
        sumOfTotalMandatory = 0;
        sumOfTotalCsv = 0;
        sumOfTax = 0;
      } else {
        sumOfTotalMandatory = totalMandatory;
        sumOfTotalCsv = matchCsv;
        sumOfTax = tax;
      }

      const netAmount = calculate(earnedBasic, [
        { type: "add", value: earnedPeraAda },
        {
          type: "subtract",
          value: sumOfTax + sumOfTotalMandatory + sumOfTotalCsv,
        },
      ]);

      secondCaseLists[id] = {
        payrollCode,
        pera,
        earnedBasic,
        earnedPeraAda,
        overpaymentBasic,
        overpaymentPeraAda,
        phic,
        pagibig,
        gsisLR,
        // tax,
        // taxDue,
        netAmount,
        minsToBeDeduc,
        daysTobeDeduc,
        halfDaysDeduc,
        gsisInsuredDays,
        daysInMonth,
        leaveAbsenceTardyDeducts,
        peraDeducts,
        // netMandatory,
        gsis,
        dateOfAbsences,
        dateOfHalfDays,
        dateOfLeaves,
      };
    } else if (thirdCase) {
      const pera = 2000;
      const daysTobeDeduc = daysToBeDeduc[id];
      const halfDaystoDeduc = halfdaysDeduc[id];
      const minutesToDeduc = minsToBeDeduc[id];
      const daysInMonth = daysInaMonth[id];
      const periodRange = periodCount[id];

      console.log("periodRange", periodRange);
      console.log("daysInMonth", daysInMonth);
      console.log("daysTobeDeduc", daysTobeDeduc);

      console.log("taxArr", taxArr);

      const overpaymentPeraAda = value[index]?.["overpaymentPeraAda"] ??
        overPaymentPera[id] ?? [0];
      const overpaymentBasic = value[index]?.["overpaymentBasic"] ??
        overPaymentBasic[id] ?? [0];
      const tax = value[index]?.["tax"] ?? taxArr[id] ?? [0];
      const pagibig = value[index]?.["pagibig"] ?? pagibigArr[id] ?? [0];
      const phicArr = value[index]?.["phic"] ?? phic[id] ?? [0];

      console.log("TAXXX", tax);

      console.log("phicArrs", phicArr);

      let gsisInsuredDays;
      let basicRateForBackPay;
      let peraAdaForBackPay;

      if (Array.isArray(daysInMonth) && Array.isArray(daysTobeDeduc)) {
        gsisInsuredDays = periodRange.map((days, index) => {
          const absence = daysTobeDeduc[index] ?? 0;
          const halfDay = halfDaystoDeduc[index] ?? 0;
          const halfDayValue = halfDay * 0.5;

          return days - absence - halfDayValue;
        });
      }

      const firstCalcforTardy = calculateArray(salary, [
        { type: "/", value: 22 },
        { type: "*", value: daysTobeDeduc },
      ]);
      const secondCalcforTardy = calculateArray(salary, [
        { type: "/", value: 22 },
        { type: "/", value: 2 },
        { type: "*", value: halfDaystoDeduc },
      ]);
      const thirdCalcforTardy = calculateArray(salary, [
        { type: "/", value: 22 },
        { type: "/", value: 8 },
        { type: "/", value: 60 },
        { type: "*", value: minutesToDeduc },
      ]);

      const firstCalcforPera = calculateArray(2000, [
        { type: "/", value: 22 },
        { type: "*", value: daysTobeDeduc },
      ]);

      const secondCalcforPera = calculateArray(2000, [
        { type: "/", value: 22 },
        { type: "/", value: 2 },
        { type: "*", value: halfDaystoDeduc },
      ]);

      const thirdCalcforPera = calculateArray(2000, [
        { type: "/", value: 22 },
        { type: "/", value: 8 },
        { type: "/", value: 60 },
        { type: "*", value: minutesToDeduc },
      ]);

      const deductionsDueToLeavesAbsencesAndTardinessBasic = calculateArray(
        firstCalcforTardy,
        [
          { type: "+", value: secondCalcforTardy },
          { type: "+", value: thirdCalcforTardy },
        ]
      );

      const deductionPeraAda = calculateArray(firstCalcforPera, [
        { type: "+", value: secondCalcforPera },
        { type: "+", value: thirdCalcforPera },
      ]);

      if (Array.isArray(periodRange)) {
        basicRateForBackPay = calculateBackPay(salary, periodRange);
        peraAdaForBackPay = calculateBackPay(2000, periodRange);
      }

      const earnedBasic = calculateArray(basicRateForBackPay, [
        { type: "-", value: deductionsDueToLeavesAbsencesAndTardinessBasic },
        { type: "-", value: overpaymentBasic },
      ]);

      const earnedPeraAda = calculateArray(peraAdaForBackPay, [
        { type: "-", value: deductionPeraAda },
        { type: "-", value: overpaymentPeraAda },
      ]);

      const groupedBasic = groupAndSumByMonth(earnedBasic, monthNamesArr[id]);
      const groupedPera = groupAndSumByMonth(earnedPeraAda, monthNamesArr[id]);
      const groupedTax = groupAndSumByMonth(tax, monthNamesArr[id]);
      const groupedGsis = groupAndSumByMonth(gsisLR[id], monthNamesArr[id]);
      const groupedPhic = groupAndSumByMonth(phic[id], monthNamesArr[id]);
      const groupedPagibig = groupAndSumByMonth(pagibig, monthNamesArr[id]);

      const basicValues = groupedBasic.map((item) => item.value);
      const peraValues = groupedPera.map((item) => item.value);
      const taxValues = groupedTax.map((item) => item.value);
      const gsisValues = groupedGsis.map((item) => item.value);
      const phicValues = groupedPhic.map((item) => item.value);
      const pagibigValues = groupedPagibig.map((item) => item.value);

      const deductions = calculateArray(taxValues, [
        { type: "+", value: gsisValues },
        { type: "+", value: phicValues },
        { type: "+", value: pagibigValues },
      ]);

      const netAmountValues = calculateArray(basicValues, [
        { type: "+", value: peraValues },
        { type: "-", value: deductions },
        { type: "-", value: deductionsFromCsv[agency] },
      ]);

      console.log("netAmountValues", netAmountValues);

      const netAmount = groupedBasic.map((item, index) => {
        return `${item?.month} - ${netAmountValues[index]}`;
      });

      thirdCaseLists[id] = {
        payrollCode,
        pera,
        earnedBasic,
        earnedPeraAda,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        pagibig,
        phicArr,
        netAmount,
        gsisInsuredDays,
        basicRateForBackPay,
        peraAdaForBackPay,
        deductionsDueToLeavesAbsencesAndTardinessBasic,
        deductionPeraAda,
      };
    } else if (fourthCase) {
      const percentage = otherInfo?.percentage;
      let minsToBeDeduc = minsToDeducAdd[id];
      let daysTobeDeduc = daysToDedudAdd[id];

      console.log("daysTobeDeduc", daysTobeDeduc);
      const minsToBeDeducAirport = minsToDeducAirport[id];
      const daysToBeDeducAirport = daysToDeducAirport[id];
      const amountForAugmented = extractSalary(natureOfFunction);

      if (id === "f174ed64-09af-4609-95f5-45ab768024c0") {
        minsToBeDeduc = 330;
        daysTobeDeduc = 20;
      }

      const apRateValue = calculate(percentage, [
        { type: "multiply", value: payCode },
        { type: "divide", value: 100 },
      ]);

      const apRate = value[index]?.["apRate"] ?? apRateValue;

      let assignedHours = 0;

      if (twentyFourSeven === "9 Hours") {
        assignedHours = 9;
      } else if (twentyFourSeven === "10.5 Hours") {
        assignedHours = 10.5;
      } else {
        assignedHours = 12;
      }

      // const taxDues = getTotalNetOfMandatory(
      //   formatted,
      //   annualTax,
      //   "Basic Pay",
      //   "annualTax"
      // );

      // const taxDuesGenerated = getTotalNetOfMandatory(
      //   formatted,
      //   annualTax,
      //   "Basic Pay",
      //   "annualTaxation"
      // );

      // const generatedPayCode = getTotalNetOfMandatory(
      //   formatted,
      //   monthlyPayCode,
      //   "Augmentation Pay",
      //   "payCode"
      // );
      // const generatedNetEarned = getTotalNetOfMandatory(
      //   formatted,
      //   netEarned,
      //   "Augmentation Pay",
      //   "payCode"
      // );

      // const amntNetMandatory = getExactNetOfMandatory(
      //   formatted,
      //   netOfMandatory,
      //   "Basic Pay"
      // );

      // const totalMonthlyAPTax = getTotalNetOfMandatory(
      //   formatted,
      //   monthlyTax,
      //   "Augmentation Pay",
      //   "monthlyTax"
      // );

      const daysInAirport = numberOfDutiesinAP?.result?.[id] ?? 0;
      const apAugmentationRate = daysInAirport > 0 ? amountForAugmented : 0;

      const overpayment = value[index]?.["overpayment"] ?? 0;
      const flagRaising = value[index]?.["flagRaising"] ?? 0;
      const numberOfDuty =
        value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ?? 22;
      const excessAirportDuty = value[index]?.["excessAirportDuties"] ?? 0;

      const proratedApRate = calculate(numberOfDuty, [
        { type: "subtract", value: daysInAirport },
        { type: "multiply", value: apRate },
        { type: "divide", value: numberOfDuty },
      ]);

      const absencesLeaves_1 = calculate(apRate, [
        { type: "divide", value: numberOfDuty },
        { type: "multiply", value: daysTobeDeduc },
        ,
      ]);

      const lateUtCurrentAss = calculate(apRate, [
        { type: "divide", value: numberOfDuty },
        { type: "divide", value: assignedHours },
        { type: "divide", value: 60 },
        { type: "multiply", value: minsToBeDeduc },
      ]);

      const earnedCurrAss = calculate(proratedApRate, [
        { type: "subtract", value: absencesLeaves_1 },
        { type: "subtract", value: lateUtCurrentAss },
      ]);

      const airportAugAmt = calculate(apAugmentationRate, [
        { type: "divide", value: 22 },
        { type: "multiply", value: daysInAirport },
      ]);
      const absencesLeaves_2 = calculate(apAugmentationRate, [
        { type: "divide", value: numberOfDuty },
        { type: "multiply", value: daysToBeDeducAirport },
      ]);

      const lateUtAirportAss = calculate(50000, [
        { type: "divide", value: numberOfDuty },
        { type: "divide", value: 9 },
        { type: "divide", value: 60 },
        { type: "multiply", value: minsToBeDeducAirport },
      ]);

      const airportDutyEarned = calculate(airportAugAmt, [
        { type: "subtract", value: absencesLeaves_2 },
        { type: "subtract", value: lateUtAirportAss },
      ]);

      const totalEarned = calculate(earnedCurrAss, [
        { type: "add", value: airportDutyEarned },
        { type: "add", value: excessAirportDuty },
      ]);

      const netEarn = calculate(totalEarned, [
        { type: "subtract", value: overpayment },
        { type: "subtract", value: flagRaising },
      ]);

      // const getGeneratedBasic = getTotalNetOfMandatory(
      //   formatted,
      //   netEarned,
      //   "Basic Pay",
      //   "netEarned"
      // );

      // const tax = calculateApTax(
      //   netEarn,
      //   monthIndex,
      //   apRate,
      //   salary,
      //   taxes,
      //   sumTaxableAllowance[id],
      //   sumallContributions[id],
      //   totalNetMandatory,
      //   amntNetMandatory,
      //   taxDuesGenerated,
      //   generatedNetEarned,
      //   totalMonthlyAPTax,
      //   getGeneratedBasic
      // );

      // const apTax = tax?.monthlyApTax;
      // const taxDue = tax?.remainingTaxDue;
      console.log("matchCsv", matchCsv);
      const netAmount = calculate(netEarn, [
        { type: "subtract", value: tax + matchCsv },
      ]);

      fourthCaseLists[id] = {
        payrollCode,
        apRate,
        proratedApRate,
        daysInAirport,
        minsToBeDeduc,
        daysTobeDeduc,
        minsToBeDeducAirport,
        daysToBeDeducAirport,
        lateUtCurrentAss,
        absencesLeaves_1,
        // taxDue,
        // tax: apTax,
        overpayment,
        flagRaising,
        excessAirportDuty,
        numberOfDuty,
        earnedCurrAss,
        apAugmentationRate,
        absencesLeaves_2,
        lateUtAirportAss,
        airportAugAmt,
        airportDutyEarned,
        totalEarned,
        netEarned: netEarn,
        netAmount,
      };
    } else if (fifthCase) {
      const minsToBeDeduc = minsToDeducAdd[id];
      const daysTobeDeduc = daysToDedudAdd[id];
      const halfDaysDeduc = halfDaysDeducdAdd[id];
      const isGrad = isGraduated === "YES";
      const isAnnexSubmitted = isSubmitted === "YES";
      const sumTaxesFromCsv = taxPercentFromCsv[agency];
      const sumDeductionsFromCsv = deductionsFromCsv[agency];

      const overpayment = value[index]?.["overpayment"] ?? 0;
      const flagRaising = value[index]?.["flagRaising"] ?? 0;

      let threePercent = 0;
      // let twoPercent = 0;
      // let fivePercent = 0;
      // let tenPercent = 0;
      let assignedHours = 0;

      if (twentyFourSeven === "9 Hours") {
        assignedHours = 9;
      } else if (twentyFourSeven === "10.5 Hours") {
        assignedHours = 10.5;
      } else {
        assignedHours = 12;
      }

      const numberOfDays = value[index]?.["noOfDays"] ?? 22;
      const absencesDays = calculate(salary, [
        { type: "multiply", value: daysTobeDeduc },
        { type: "divide", value: numberOfDays },
      ]);

      const absencesMins = calculate(salary, [
        { type: "divide", value: numberOfDays },
        { type: "divide", value: assignedHours },
        { type: "divide", value: 60 },
        { type: "multiply", value: minsToBeDeduc },
      ]);

      const earnedFoPeriod = calculate(salary, [
        { type: "subtract", value: absencesDays },
        { type: "subtract", value: absencesMins },
        { type: "subtract", value: overpayment },
        { type: "subtract", value: flagRaising },
      ]);

      const totalEarnedForPeriod = getTotalNetOfMandatory(
        formatted,
        earnedForThePeriod,
        "Basic Pay",
        "netOfMandatory"
      );

      const joTax = calculateJOTax(
        salary,
        monthIndex,
        gratuityAllowance[id],
        totalEarnedForPeriod
      );

      if (isGrad) {
        threePercent = calculate(earnedFoPeriod, [
          { type: "multiply", value: 0.03 },
        ]);
      }

      // if (percentTag === "2%" && isAnnexSubmitted) {
      //   twoPercent = calculate(joTax, [
      //     { type: "divide", value: monthIndex },
      //     { type: "multiply", value: 0.02 },
      //   ]);
      // } else if (percentTag === "5%" && isAnnexSubmitted) {
      //   fivePercent = calculate(joTax, [
      //     { type: "divide", value: monthIndex },
      //     { type: "multiply", value: 0.05 },
      //   ]);
      // } else {
      //   tenPercent = calculate(joTax, [
      //     { type: "divide", value: monthIndex },
      //     { type: "multiply", value: 0.1 },
      //   ]);
      // }

      const totalTax = calculate(threePercent, [
        { type: "add", value: sumTaxesFromCsv },
        // { type: "add", value: twoPercent },
        // { type: "add", value: fivePercent },
        // { type: "add", value: tenPercent },
      ]);

      const netPay = calculate(earnedFoPeriod, [
        { type: "subtract", value: totalTax },
        { type: "subtract", value: sumDeductionsFromCsv },
      ]);

      fifthCaseLists[id] = {
        minsToBeDeduc,
        daysTobeDeduc,
        halfDaysDeduc,
        absencesDays,
        absencesMins,
        overpayment,
        flagRaising,
        earnedFoPeriod,
        threePercent,
        salary,
        // twoPercent,
        // fivePercent,
        // tenPercent,
        totalTax,
        netPay,
      };
    } else if (sixthCase) {
      const periodRange = periodCount[id];
      const daysTobeDeduc = daysToBeDeduc[id];
      const minsToDeduc = minsToBeDeducted[id];
      const numberofDays = numOfDays[id];
      const overPayment = ovrPayment[id];
      const flagraising = flgRaising[id];
      const threePercnt = three[id];
      const twoPercnt = two[id];
      const fivePercnt = five[id];
      const tenPercnt = ten[id];

      const overpayment = value[index]?.["overpayment"] ?? overPayment ?? [0];
      const flagRaising = value[index]?.["flagRaising"] ?? flagraising ?? [0];
      const noOfDays = value[index]?.["noOfDays"] ?? numberofDays ?? [22];
      const threePercent = value[index]?.["3"] ?? threePercnt ?? [0];
      const twoPercent = value[index]?.["2"] ?? twoPercnt ?? [0];
      const fivePercent = value[index]?.["5"] ?? fivePercnt ?? [0];
      const tenPercent = value[index]?.["10"] ?? tenPercnt ?? [0];

      let assignedHours = [];

      noOfDays.forEach(() => {
        if (twentyFourSeven === "9 Hours") {
          assignedHours.push(9);
        } else if (twentyFourSeven === "10.5 Hours") {
          assignedHours.push(10.5);
        } else {
          assignedHours.push(12);
        }
      });

      let basicRateForBackPay;
      if (Array.isArray(periodRange)) {
        basicRateForBackPay = calculateBackPay(salary, periodRange);
      }

      const absencesDays = calculateArray(basicRateForBackPay, [
        { type: "*", value: daysTobeDeduc },
        { type: "/", value: noOfDays },
      ]);

      const absencesMins = calculateArray(basicRateForBackPay, [
        { type: "*", value: minsToDeduc },
        { type: "/", value: noOfDays },
        { type: "/", value: assignedHours },
      ]);

      const earnedForThePeriod = calculateArray(basicRateForBackPay, [
        { type: "-", value: absencesDays },
        { type: "-", value: absencesMins },
        { type: "-", value: overpayment },
        { type: "-", value: flagRaising },
      ]);

      const totalTax = calculateArray(threePercent, [
        // { type: "+", value: twoPercent },
        // { type: "+", value: fivePercent },
        // { type: "+", value: tenPercent },
        { type: "+", value: taxPercentFromCsv[agency] },
      ]);

      console.log("totalTax", totalTax);

      const groupedEarnedForPrd = groupAndSumByMonth(
        earnedForThePeriod,
        monthNamesArr[id]
      );
      const groupedTotalTax = groupAndSumByMonth(totalTax, monthNamesArr[id]);

      const earnedPeriodValues = groupedEarnedForPrd.map((item) => item.value);
      const totalTaxValues = groupedTotalTax.map((item) => item.value);

      const netPayValues = calculateArray(earnedPeriodValues, [
        { type: "-", value: totalTaxValues },
        { type: "-", value: deductionsFromCsv[agency] },
      ]);

      const netAmount = groupedEarnedForPrd.map((item, index) => {
        return `${item?.month} - ${netPayValues[index]}`;
      });

      sixthCaseLists[id] = {
        overpayment,
        flagRaising,
        basicRateForBackPay,
        absencesDays,
        absencesMins,
        noOfDays,
        earnedForThePeriod,
        threePercent,
        twoPercent,
        fivePercent,
        tenPercent,
        totalTax,
        netAmount,
      };
    } else if (seventhCase) {
      const pera = 2000;
      const holWkendsOff = 0;
      const actualWorkingDays = workingDays[id];
      const daysTobeDeduc = daysToDedudAdd[id];
      const halfdaysTobeDeduc = halfDaysDeducdAdd[id];
      const minsToBeDeduc = minsToDeducAdd[id];
      const pagibig = value[index]?.["pagibig"] ?? 0;
      // const phic = value[index]?.["phic"] ?? 0;
      const tax = value[index]?.["tax"] ?? 0;

      const periodCount = getRangeInSelectedDate(datePicked);

      const params = {
        id,
        actualWorkDays,
        absentDateByEmployee,
        halfDateByEmployee,
      };

      const inServiceCount = getInServiceCount(params);

      // const inService = Math.min(
      //   calculate(actualWorkingDays, [
      //     { type: "subtract", value: daysTobeDeduc },
      //   ]),
      //   22
      // );

      const inService = inServiceCount;

      const inServiceMax = inService > 22 ? 22 : inService;

      const insuredDays = calculate(periodCount, [
        { type: "subtract", value: daysTobeDeduc },
      ]);

      const gsis = calculate(salary, [
        { type: "multiply", value: insuredDays },
        { type: "divide", value: daysInMonth },
        { type: "multiply", value: 0.09 },
      ]);

      let mandatoryDeduc = sumObjContributions(contributions);

      // if (payItems === "Last") {
      //   mandatoryDeduc[id] -= 200;
      // }
      const totalMandatory = calculate(mandatoryDeduc[id], [
        { type: "add", value: gsis },
      ]);

      const proratedRate = calculate(salary, [
        { type: "multiply", value: inServiceMax },
        { type: "divide", value: 22 },
      ]);

      const proratedPera = calculate(2000, [
        { type: "multiply", value: inServiceMax },
        { type: "divide", value: 22 },
      ]);

      const perDay = calculate(salary, [{ type: "divide", value: 22 }]);
      const perHalfDay = calculate(salary, [
        { type: "divide", value: 22 },
        { type: "divide", value: 2 },
      ]);

      const perMinute = calculate(salary, [
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
      ]);

      const perDay2 = calculate(2000, [{ type: "divide", value: 22 }]);

      const perMinute2 = calculate(2000, [
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
      ]);

      const days2 = calculate(daysTobeDeduc, [
        { type: "multiply", value: perDay },
      ]);

      const halfDays2 = calculate(halfdaysTobeDeduc, [
        { type: "multiply", value: perHalfDay },
      ]);

      const mins2 = calculate(salary, [
        // { type: "multiply", value: perMinute },
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
        { type: "multiply", value: minsToBeDeduc },
      ]);

      console.log("mins2", mins2);

      const basic = calculate(days2, [
        { type: "add", value: halfDays2 },
        { type: "add", value: mins2 },
      ]);

      const days3 = calculate(daysTobeDeduc, [
        { type: "multiply", value: perDay2 },
      ]);
      const mins3 = calculate(2000, [
        // { type: "multiply", value: perMinute2 },
        { type: "divide", value: 22 },
        { type: "divide", value: 8 },
        { type: "divide", value: 60 },
        { type: "multiply", value: minsToBeDeduc },
      ]);

      const pera2 = calculate(days3, [{ type: "add", value: mins3 }]);

      const basicEarned = calculate(proratedRate, [
        { type: "subtract", value: mins2 },
      ]);
      const peraEarned = calculate(proratedPera, [
        { type: "subtract", value: mins3 },
      ]);
      const total = calculate(basicEarned, [
        { type: "add", value: peraEarned },
      ]);

      const netPay = calculate(total, [
        { type: "subtract", value: tax },
        { type: "subtract", value: totalMandatory },
        { type: "subtract", value: pagibig },
        // { type: "subtract", value: phic },
      ]);

      seventhCaseLists[id] = {
        pera,
        inService: inServiceMax,
        daysInMonth,
        holWkendsOff,
        proratedRate,
        proratedPera,
        perDay,
        perMinute,
        perDay2,
        perMinute2,
        daysTobeDeduc,
        halfdaysTobeDeduc,
        minsToBeDeduc,
        insuredDays,
        days2,
        halfDays2,
        mins2,
        basic,
        days3,
        mins3,
        pera2,
        basicEarned,
        peraEarned,
        total,
        tax,
        pagibig,
        // phic,
        gsis,
        netPay,
      };
    } else if (eightCase) {
      const minsToBeDeduc = minsToDeducAdd[id];
      const actualWorkingDays = workingDays[id];
      // const daysTobeDeduc = daysToDedudAdd[id];
      const overPayment = ovrPayment[id];
      const flagraising = flgRaising[id];
      const totalAbsences = daysToBeDeduc[id];
      const totalLatesUt = minsToBeDeducted[id];
      const workingDates = workingDatesLists[id];
      const allMinsIncurred = minsIncurred[id];

      const fixed =
        Array.isArray(allMinsIncurred) && allMinsIncurred.length > 0
          ? allMinsIncurred.map((v) => Number(parseFloat(v).toFixed(2)))
          : allMinsIncurred;


      const overpayment = value[index]?.["overpayment"] ?? overPayment ?? [0];
      const flagRaising = value[index]?.["flagRaising"] ?? flagraising ?? [0];
      const tax = value[index]?.["tax"] ?? 0;
      const taxConverted = [tax];

      console.warn("tax", tax);

      const earnedDays = getActualAttendanceDates(workingDates, totalAbsences);
      console.log("daysEarned", earnedDays);

      const apRate = value[index]?.["apRate"] ?? apRateAmount[id] ?? [payCode];

      const numberOfDuty = value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ??
        dutyForCiaMciaBinoc[id] ?? [22];

      console.log("numberOfDuty", numberOfDuty);

      const inService = calculate(actualWorkingDays, [
        { type: "subtract", value: daysTobeDeduc },
      ]);

      const latesUtDeduction = calculateArray(apRate, [
        { type: "/", value: 22 },
        { type: "/", value: 8 },
        { type: "/", value: 60 },
        { type: "*", value: totalLatesUt },
      ]);

      const earnedForThePeriod = calculateArray(apRate, [
        { type: "/", value: 22 },
        { type: "*", value: earnedDays },
        { type: "-", value: fixed },
        { type: "-", value: overpayment },
        { type: "-", value: flagRaising },
      ]);

      console.log("eARNED FOR THYE PERIOD", earnedForThePeriod);

      const groupedEarned = groupAndSumByMonth(
        earnedForThePeriod,
        monthNamesArr[id]
      );

      const groupTotalTax = groupAndSumByMonth(tax, monthNamesArr[id]);
      const earnedPeriodValues = groupedEarned.map((item) => item.value);
      const taxValues = groupTotalTax.map((item) => item.value);

      console.log("groupTotalTax", groupTotalTax);

      console.log("GROUPPP TOTAL", groupedEarned);

      const netAmount = calculateArray(earnedPeriodValues, [
        { type: "-", value: tax },
      ]);

      // const netAmount = groupedEarned.map((item, index) => {
      //   return `${item?.month} - ${netPayValues[index]}`;
      // });

      console.log("netAmount");

      eightCaseLists[id] = {
        apRate,
        payCode,
        minsToBeDeduc,
        latesUtDeduction: fixed,
        totalLatesUt,
        daysEarned: earnedDays,
        overpayment,
        flagRaising,
        numberOfDuty,
        earnedForThePeriod,
        tax: taxConverted,
        netAmount,
      };
    } else if (ninthCase) {
      const rata = rataAllowance[id];
      const actualWorkingDays = workingDays[id];
      const daysTobeDeduc = daysToDedudAdd[id];

      const inService = calculate(actualWorkingDays, [
        { type: "subtract", value: daysTobeDeduc },
      ]);

      let actualRataForAMonth = 0;

      if (inService >= 1 && inService <= 5) {
        actualRataForAMonth = 25;
      } else if (inService >= 6 && inService <= 11) {
        actualRataForAMonth = 50;
      } else if (inService >= 12 && inService <= 16) {
        actualRataForAMonth = 75;
      } else if (inService >= 17) {
        actualRataForAMonth = 100;
      }

      const concatPercent = `${actualRataForAMonth}%`;
      const percentageDecimal = actualRataForAMonth / 100;

      const netAmount = calculate(rata, [
        { type: "multiply", value: percentageDecimal },
      ]);

      ninthCaseLists[id] = {
        rata,
        inService,
        concatPercent,
        netAmount,
      };
    } else if (tenthCase) {
      const myDiff = value[index]?.["myDiff"] ?? 0;
      const yeDiff = value[index]?.["yeDiff"] ?? 0;
      const tax = value[index]?.["tax"] ?? 0;

      const params = {
        salary,
        daysToBeDeducted,
        halfDaysToBeDeducted,
        minutesToBeDeducted,
      };

      const itemForOldRate = _getItemOldRate(earnedBasic, datePicked);
      const itemForNewRate = _getItemNewRate(params);

      console.log("itemForNewRate", itemForNewRate);

      console.log("itemForOldRate", itemForOldRate);
      const itemForMandatory = _getItemOldRate(mandatoryDeductions, datePicked);

      const gsisOldRate = getGsisOldRate(itemForMandatory, "gsisLR");

      const gsisNewRate = getGsisNewRate(
        gsisInsuredDays,
        daysInAmonth,
        salary,
        mandatoryFormula,
        mandatoryDeductions,
        "gsisLR"
      );

      const phicOldRate = getGsisOldRate(itemForMandatory, "phic");

      const phicNewRate = getGsisNewRate(
        gsisInsuredDays,
        daysInAmonth,
        salary,
        mandatoryFormula,
        mandatoryDeductions,
        "phic"
      );
      console.log("phicNewRate", phicNewRate);

      console.log("salary", salary);

      const salaryDifferential = _getSalaryDiff(itemForOldRate, itemForNewRate);

      console.log("salaryDifferential", salaryDifferential);

      const gsis = calculate(gsisNewRate, [
        { type: "subtract", value: gsisOldRate },
      ]);
      const phic = calculate(phicNewRate, [
        { type: "subtract", value: phicOldRate },
      ]);

      // const tax = 0;
      const netPay = calculate(salaryDifferential, [
        { type: "subtract", value: gsis },
        { type: "subtract", value: phic },
        { type: "subtract", value: tax },
        { type: "add", value: myDiff },
        { type: "add", value: yeDiff },
      ]);

      tenthCaseLists[id] = {
        salaryDifferential,
        gsis,
        phic,
        tax,
        myDiff,
        yeDiff,
        netPay,
        oldPositionTitle,
        oldSalaryGrade,
      };
    } else if (eleventhCase) {
      const daysTobeDeduc = daysToDedudAdd[id];

      const actualWorkingDays = workingDays[id];
      const isGrad = isGraduated === "YES";
      const isAnnexSubmitted = isSubmitted === "YES";
      const twoPercent = value[index]?.["2"] ?? 0;
      const gratuityPay = value[index]?.["gratuityPay"] ?? 0;
      const allMinsIncurred = minsIncurred[id];
      const notArrMinsIncurred = parseFloat(minsIncurredLists[id].toFixed(2));

      const fixed =
        Array.isArray(allMinsIncurred) && allMinsIncurred.length > 0
          ? allMinsIncurred.map((v) => Number(parseFloat(v).toFixed(2)))
          : allMinsIncurred;

      let numberOfDuty;
      let threePercent = 0;
      let inService = 0;
      let proratedRate = 0;
      let minsToBeDeduc;
      let absMins = 0;
      let earned = 0;
      let netAmount = 0;
      // = calculate(actualWorkingDays, [
      //   { type: "subtract", value: daysTobeDeduc },
      // ]);

      console.log("ACTUAL");

      const params = {
        id,
        actualWorkDays,
        absentDateByEmployee,
      };

      console.log("actualWorkDays", actualWorkDays);

      // const res = actualWorkDays[id].length - deduc;

      // console.log("RESSS", res);

      const inServiceCount = getInServiceCount(params);

      let count = 0;

      if (twentyFourSeven === "10.5 Hours") {
        count = 10.5;
      } else if (twentyFourSeven === "9 Hours") {
        count = 9;
      } else {
        count = 12;
      }

      console.log("COUNT", count);

      if (payItems === "Initial") {
        inService = inServiceCount;

        numberOfDuty = value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ?? 22;
        proratedRate = calculate(salary, [
          { type: "multiply", value: inService },
          { type: "divide", value: numberOfDuty },
        ]);
        minsToBeDeduc = minsToDeducAdd[id];
        absMins = notArrMinsIncurred;
        earned = calculate(salary, [
          { type: "divide", value: 22 },
          { type: "multiply", value: inService },
          { type: "subtract", value: absMins },
        ]);
      } else {
        const workingDates = workingDatesLists[id];
        const totalAbsences = daysToBeDeduc[id];

        inService = getActualAttendanceDates(workingDates, totalAbsences);

        numberOfDuty = value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ??
          dutyForCiaMciaBinoc[id] ?? [22];

        proratedRate = calculateArray(salary, [
          { type: "*", value: inService },
          { type: "/", value: numberOfDuty },
        ]);

        console.log("proratedRate", proratedRate);
        minsToBeDeduc = minsToBeDeducted[id];
        absMins = fixed;
        // absMins = calculateArray(salary, [
        //   { type: "/", value: 22 },
        //   { type: "/", value: count },
        //   { type: "/", value: 60 },
        //   { type: "*", value: minsToBeDeduc },
        // ]);

        const deducAbsMins = calculateArray(salary, [
          { type: "/", value: 22 },
          { type: "*", value: inService },
          { type: "-", value: absMins },
        ]);

        const sumForEarned =
          deducAbsMins?.reduce((total, num) => total + num, 0) || 0;
        earned = sumForEarned;
      }

      console.log("numberOfDuty", numberOfDuty);

      console.log("in servicee", inService);

      // const perDay = calculate(salary, [{ type: "divide", value: 22 }]);
      // const perMinute = calculate(salary, [
      //   { type: "divide", value: 22 },
      //   { type: "divide", value: 10.5 },
      //   { type: "divide", value: 60 },
      // ]);

      // const absDays = calculate(perDay, [
      //   { type: "multiply", value: daysTobeDeduc },
      // ]);

      const twentyPercent = calculate(earned, [
        { type: "multiply", value: 0.2 },
      ]);
      const totalEarned = calculate(earned, [
        { type: "add", value: twentyPercent },
        { type: "add", value: gratuityPay },
      ]);

      if (isGrad) {
        threePercent = calculate(totalEarned, [
          { type: "multiply", value: 0.03 },
        ]);
      }

      // const joTax = calculateJOTax(
      //   salary,
      //   monthIndex,
      //   gratuityAllowance[id],
      //   0
      // );

      // if (percentTag === "2%" && isAnnexSubmitted) {
      //   twoPercent = calculate(joTax, [
      //     { type: "divide", value: monthIndex },
      //     { type: "multiply", value: 0.02 },
      //   ]);
      // }

      if (payItems === "Initial") {
        netAmount = calculate(totalEarned, [
          { type: "subtract", value: threePercent },
          // { type: "subtract", value: twoPercent },
        ]);
      } else {
        const groupedTotalEarned = groupAndSumByMonth(
          totalEarned,
          monthNamesArr[id]
        );

        netAmount = calculateArray(
          [totalEarned],
          [{ type: "-", value: [threePercent] }]
        );

        // netAmount = groupedTotalEarned.map((item, index) => {
        //   return `${item?.month} - ${netPayValues[index]}`;
        // });
      }

      console.log("netAmount", netAmount);

      console.log("ABSSS MINS", absMins);

      eleventhCaseLists[id] = {
        salary,
        numberOfDuty,
        // perDay,
        // perMinute,
        daysTobeDeduc,
        minsToBeDeduc,
        proratedRate,
        gratuityPay,
        // absDays,
        absMins,
        inService,
        earned,
        twentyPercent,
        threePercent,
        twoPercent,
        totalEarned,
        netAmount,
      };
    } else if (twelveCase) {
      const percentage = otherInfo?.percentage;
      const amountForAugmented = extractSalary(natureOfFunction);

      const apRateValue = calculate(percentage, [
        { type: "multiply", value: payCode },
        { type: "divide", value: 100 },
      ]);

      const apRate = value[index]?.["apRate"] ?? apRateValue;

      const workDays = workingDatesLists[id] || [];
      const absences = dateOfAbsences[id] || [];

      const presentWorkDaysByIndex = workDays.map((days, idx) => {
        const absSet = absences[idx] || new Set();
        return days.filter((date) => !absSet.has(date));
      });

      const lengths = presentWorkDaysByIndex.map(arr => arr.length);

      // const params = {
      //   id,
      //   workDays,
      //   absentDateByEmployee,
      // };

      // const inServiceCount = getInServiceCount(params);

      // const periodRange = periodCount[id];
      const ciaMciaBinoc = value[index]?.["OfDutyForCiaMciaBinocRangeTo1519"] ??
        dutyForCiaMciaBinoc[id] ?? [22];
      const noOfDuties = noOfDutiesInAirport[id] || [];
      const minsTobeDeducCurrAss = minsDeducForReg[id];
      const daysTobeDeducCurrAss = daysDeducForReg[id];
      const minsTobeDeducAirport = minsDeducForAirport[id];
      const daysTobeDeducAirport = daysDeducForAirport[id];
      const overPayment = ovrPayment[id];
      const flagraising = flgRaising[id];
      const excessAirportDuty = excessAirport[id];
      const overpayment = value[index]?.["overpayment"] ?? overPayment ?? [0];
      const flagRaising = value[index]?.["flagRaising"] ?? flagraising ?? [0];
      const excessAirportDuties = value[index]?.["excessAirportDuties"] ??
        excessAirportDuty ?? [0];
      const taxes = updatedTax[id];
      const tax = value[index]?.["tax"] ?? taxes ?? [0];


      let assignedHours = 0;

      if (twentyFourSeven === "9 Hours") {
        assignedHours = 9;
      } else if (twentyFourSeven === "10.5 Hours") {
        assignedHours = 10.5;
      } else {
        assignedHours = 12;
      }

      // let apRateForBackPay;
      // if (Array.isArray(periodRange)) {
      //   apRateForBackPay = calculateBackPay(apRate, count);
      // }

      console.log("apRate", apRate);

      const apRateForBackPay = calculateArray(apRate, [
        { type: "/", value: ciaMciaBinoc },
        { type: "*", value: lengths },
      ]);

      const proratedApRate = calculateArray(ciaMciaBinoc, [
        { type: "-", value: noOfDuties },
        { type: "*", value: apRateForBackPay },
        { type: "/", value: ciaMciaBinoc },
      ]);


      const absenceLeavesCurAss = calculateArray(apRateForBackPay, [
        { type: "/", value: ciaMciaBinoc },
        { type: "*", value: daysTobeDeducCurrAss },
      ]);

      const latesUtCurAss = calculateArray(apRateForBackPay, [
        { type: "/", value: ciaMciaBinoc },
        { type: "/", value: assignedHours },
        { type: "/", value: 60 },
        { type: "*", value: minsTobeDeducCurrAss },
      ]);

      const earnedCurrAss = calculateArray(proratedApRate, [
        { type: "-", value: absenceLeavesCurAss },
        { type: "-", value: latesUtCurAss },
      ]);

      const airportAugmentationRate = noOfDuties.map((duty) =>
        duty > 0 ? amountForAugmented : 0
      );

      const airportAugAmt = calculateArray(airportAugmentationRate, [
        { type: "/", value: 22 },
        { type: "*", value: noOfDuties },
      ]);

      const absencesLeavesAirport = calculateArray(airportAugmentationRate, [
        { type: "/", value: ciaMciaBinoc },
        { type: "*", value: daysTobeDeducAirport },
      ]);

      const lateUtAirportAss = calculateArray(apRateForBackPay, [
        { type: "/", value: ciaMciaBinoc },
        { type: "/", value: assignedHours },
        { type: "/", value: 60 },
        { type: "*", value: minsTobeDeducAirport },
      ]);

      const airportDutyEarned = calculateArray(airportAugAmt, [
        { type: "-", value: absencesLeavesAirport },
        { type: "-", value: lateUtAirportAss },
      ]);

      const totalEarned = calculateArray(earnedCurrAss, [
        { type: "+", value: airportDutyEarned },
        { type: "+", value: excessAirportDuties },
      ]);

      const netEarn = calculateArray(totalEarned, [
        { type: "-", value: overpayment },
        { type: "-", value: flagRaising },
      ]);

      const groupedNetEarned = groupAndSumByMonth(netEarn, monthNamesArr[id]);
      const groupedTax = groupAndSumByMonth(tax, monthNamesArr[id]);

      const netEarnedValues = groupedNetEarned.map((item) => item.value);
      const taxValues = groupedTax.map((item) => item.value);

      const netAmountValues = calculateArray(netEarnedValues, [
        { type: "-", value: taxValues },
        { type: "-", value: matchCsv },
      ]);
      const netAmount = groupedNetEarned.map((item, index) => {
        return `${item?.month} - ${netAmountValues[index]}`;
      });


      twelveCaseLists[id] = {
        apRate,
        payCode,
        apRateForBackPay,
        ciaMciaBinoc,
        proratedApRate,
        absenceLeavesCurAss,
        latesUtCurAss,
        earnedCurrAss,
        airportAugmentationRate,
        airportAugAmt,
        absencesLeavesAirport,
        lateUtAirportAss,
        airportDutyEarned,
        overpayment,
        flagRaising,
        excessAirportDuties,
        totalEarned,
        tax,
        netEarned: netEarn,
        netAmount,
      };
    } else if (tirteenthCase) {
      const additional = sumallAdditional[agency];
      const deductions = sumallDeductions[agency];

      // const result = sumEarnedByMonthRange(earnedForThePeriod, monthFrom, monthTo);

      const netAmount = calculate(additional, [
        { type: "subtract", value: deductions },
      ]);
      tirteenthCaseLists[id] = {
        netAmount,
      };
    } else if (fourteenthCase) {
      // const additional = sumallAdditional[agency];
      // const deductions = sumallDeductions[agency];

      console.log("monthFrom", monthFrom);

      const earnedResult = sumEarnedByMonthRange(
        earnedForThePeriod,
        monthFrom,
        monthTo
      );

      console.log("earnedResult", earnedResult);

      console.log("ISSS GRADE]=UATED", isGraduated);

      const earnedFrom = earnedResult[monthFrom] ?? 0;
      const earnedTo = earnedResult[monthTo] ?? 0;

      const totalEarned = calculate(earnedFrom, [
        { type: "add", value: earnedTo },
      ]);

      const twentyPercent = calculate(totalEarned, [
        { type: "multiply", value: 0.2 },
      ]);

      let threePercent = 0;
      if (isGraduated === "YES") {
        threePercent = calculate(twentyPercent, [
          { type: "multiply", value: 0.03 },
        ]);
      } else {
        threePercent = 0;
      }

      const netAmount = calculate(twentyPercent, [
        { type: "subtract", value: threePercent },
      ]);

      const year = otherInfo?.twentyPercentYear;

      fourteenthCaseLists[id] = {
        earnedFrom,
        earnedTo,
        totalEarned,
        twentyPercent,
        year,
        threePercent,
        netAmount,
      };
    }
  }

  return {
    ...(firstCase && { firstCaseLists }),
    ...(secondCase && { secondCaseLists }),
    ...(thirdCase && { thirdCaseLists }),
    ...(fourthCase && { fourthCaseLists }),
    ...(fifthCase && { fifthCaseLists }),
    ...(sixthCase && { sixthCaseLists }),
    ...(seventhCase && { seventhCaseLists }),
    ...(eightCase && { eightCaseLists }),
    ...(ninthCase && { ninthCaseLists }),
    ...(tenthCase && { tenthCaseLists }),
    ...(tenthCase && { tenthCaseLists }),
    ...(eleventhCase && { eleventhCaseLists }),
    ...(twelveCase && { twelveCaseLists }),
    ...(tirteenthCase && { tirteenthCaseLists }),
    ...(fourteenthCase && { fourteenthCaseLists }),
  };
};

const parseAndFormat = (value) => parseFloat(formattedRate(value.toString()));

function calculateJOTax(salary, monthIndex, allowances, totalEarnedForPeriod) {
  const forcastedSalary = salary * monthIndex;

  const addedPrevEarnedforPeriod = forcastedSalary + totalEarnedForPeriod;
  const twntyPercentForcasted = addedPrevEarnedforPeriod * 0.2;
  const forcastedAnnualIncome =
    addedPrevEarnedforPeriod + twntyPercentForcasted + allowances;

  let excessOfTwoFifthy = 0;
  if (forcastedAnnualIncome > 250000) {
    excessOfTwoFifthy = parseAndFormat(forcastedAnnualIncome - 250000);
  } else {
    excessOfTwoFifthy = 0;
  }

  return excessOfTwoFifthy;
}

function _getItemOldRate(oldRate, datePicked) {
  if (!Array.isArray(oldRate) || !datePicked?.startDate || !datePicked?.endDate)
    return [];
  const start = new Date(datePicked.startDate),
    end = new Date(datePicked.endDate);
  const monthYears = [];
  for (let d = new Date(start); d <= end; d.setMonth(d.getMonth() + 1))
    monthYears.push(
      `${d.toLocaleString("en-US", { month: "long" })} - ${d.getFullYear()}`
    );

  return oldRate.filter((entry) => monthYears.some((my) => entry.includes(my)));
}

function _getItemNewRate({
  salary,
  daysToBeDeducted = [],
  halfDaysToBeDeducted = [],
  minutesToBeDeducted = [],
}) {
  const monthlyTotals = {};

  const sumByMonth = (entries, calcFn) => {
    for (const entry of entries) {
      const parsed = parseEntry(entry);

      if (!parsed) continue;
      const { month, value } = parsed;
      const deduction = calcFn(value);
      if (!monthlyTotals[month]) monthlyTotals[month] = { totalDeduction: 0 };
      monthlyTotals[month].totalDeduction += deduction;
    }
  };

  // Full days
  sumByMonth(daysToBeDeducted, (val) => (salary * val) / 22);

  // Half days
  sumByMonth(halfDaysToBeDeducted, (val) => (salary * val) / 22 / 2);

  // Minutes
  sumByMonth(minutesToBeDeducted, (val) => (salary * val) / 22 / 8 / 60);

  // Final: subtract totalDeduction from salary
  const result = {};
  for (const month in monthlyTotals) {
    const deduction = monthlyTotals[month].totalDeduction;
    result[month] = parseFloat((salary - deduction).toFixed(2));
  }

  return result;
}

function _getSalaryDiff(itemForOldRate, itemForNewRate) {
  let totalDiff = 0;

  for (const entry of itemForOldRate) {
    const parsed = parseEntry(entry);
    if (!parsed) continue;

    const { month, value: oldValue } = parsed;
    const newValue = itemForNewRate[month] ?? 0;
    const diff = newValue - oldValue;

    totalDiff += diff;
  }

  return Number(totalDiff.toFixed(2));
}

const parseEntry = (entry) => {
  const match = entry.match(/\((\w+)\s*-\s*\d+\)\s*-\s*([\d.]+)/);
  if (!match) return null;
  const [_, month, value] = match;
  return { month, value: parseFloat(value) };
};

function getGsisOldRate(arr, type) {
  if (!Array.isArray(arr) || !type) return 0;
  return arr.reduce((sum, entry) => {
    const regex = new RegExp(`\\(${type}\\):\\s*([\\d.]+)`);

    const match = entry.match(regex);
    const value = match ? parseFloat(match[1]) : 0;
    return sum + value;
  }, 0);
}

function getGsisNewRate(
  gsisInsuredDays = [],
  daysInAmonth = [],
  salary,
  mandatoryFormula,
  mandatoryDeductions = [],
  type
) {
  const uniquePrefixesSet = new Set();
  for (let i = 0; i < mandatoryDeductions.length; i++) {
    const entry = mandatoryDeductions[i];
    const match = entry.match(/^(.+?)(?:\s*\(|:)/);
    if (match) uniquePrefixesSet.add(match[1].trim());
  }
  const uniquePrefixes = Array.from(uniquePrefixesSet);

  if (!salary || !Array.isArray(mandatoryDeductions) || !type) return 0;
  let total = 0;
  const expression = mandatoryFormula?.[type];

  const extractMonthYear = (str) => {
    const match = str.match(/([A-Za-z]+\s-\s\d{4})/);
    return match ? match[1] : null;
  };

  const extractValue = (str) => {
    const match = str.match(/:\s*([\d.]+)/);
    return match ? parseFloat(match[1]) : 0;
  };

  uniquePrefixes.forEach((entry) => {
    const monthYear = extractMonthYear(entry);

    if (!entry) return;
    if (type === "gsisLR") {
      if (entry.includes("General Payroll")) {
        total += calculateAmount(expression, salary);
      } else {
        const insuredEntry = Array.isArray(gsisInsuredDays)
          ? gsisInsuredDays.find((e) => e.startsWith(entry))
          : null;

        const daysInMonthEntry = Array.isArray(daysInAmonth)
          ? daysInAmonth.find((e) => e.startsWith(monthYear))
          : null;

        const insuredDays = insuredEntry ? extractValue(insuredEntry) : 0;

        const daysInMonth = daysInMonthEntry
          ? extractValue(daysInMonthEntry)
          : 0;
        if (insuredDays && daysInMonth) {
          const firstCalc = (salary * insuredDays) / daysInMonth;

          const result = firstCalc * 0.09;

          total += result;
        }
      }
    } else if (type === "phic") {
      total += calculateAmount(expression, salary);
    }
  });
  return Math.round(total * 100) / 100;
}

const parseEarnedForPeriodEntry = (entry) => {
  if (entry == null) return null;

  if (typeof entry === "string") {
    const colonIndex = entry.lastIndexOf(":");
    if (colonIndex === -1) return null;

    const label = entry.slice(0, colonIndex).trim();
    const amount =
      parseFloat(entry.slice(colonIndex + 1).trim().replace(/,/g, "")) || 0;

    return { label, amount };
  }

  if (typeof entry === "object") {
    const label = Object.keys(entry)[0];
    if (!label) return null;

    const amount = parseFloat(Object.values(entry)[0]) || 0;
    return { label, amount };
  }

  return null;
};

const sumEarnedByMonthRange = (earnedForThePeriod = [], monthFrom, monthTo) => {
  const monthOrder = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const fromIndex = monthFrom ? monthOrder.indexOf(monthFrom) : 0;
  const toIndex = monthTo ? monthOrder.indexOf(monthTo) : 11;

  // Fallback: if both are invalid, return total sum of all months
  const isFromValid = fromIndex !== -1;
  const isToValid = toIndex !== -1;

  const totals = {
    [monthFrom || "defaultFrom"]: 0,
    [monthTo || "defaultTo"]: 0,
  };

  earnedForThePeriod.forEach((entry) => {
    const parsed = parseEarnedForPeriodEntry(entry);
    if (!parsed) return;

    const { label, amount } = parsed;
    const match = label.match(/\((.*?)\s*-\s*(\d{4})\)/);
    if (!match) return;

    const month = match[1].trim();
    const index = monthOrder.indexOf(month);
    if (index === -1) return;

    // Skip if fromIndex > toIndex
    if (isFromValid && isToValid && fromIndex > toIndex) return;

    if (index >= fromIndex && index <= toIndex) {
      if (month === monthFrom) {
        totals[monthFrom] += amount;
      } else if (month === monthTo) {
        totals[monthTo] += amount;
      }
    }
  });

  return {
    [monthFrom || "monthFrom"]: totals[monthFrom || "defaultFrom"],
    [monthTo || "monthTo"]: totals[monthTo || "defaultTo"],
  };
};
